import * as ST from './styled';

interface IProps {
    isDisable: boolean,
    onClick: () => void,
}

/**
 * Кнопка оплаты СберПэй
 */
export const SberPayButton = ({ onClick, isDisable }: IProps) => {
    return (
        <ST.SberPayButton
            disabled={isDisable}
            onClick={onClick}
        >
            <ST.InnerWrap>
                Оплатить
                <svg width={50} height={18} fill='white'>
                    <use href={'/static/images/payments-abn/pay-systems/sberpay.sprite.svg#sberpay'} />
                </svg>
            </ST.InnerWrap>
        </ST.SberPayButton>
    );
};
